<template>
  <div class="product-cart">
    <CustomButton
      v-if="canAddToCart"
      :key="slug"
      type="primary"
      size="md"
      class="product-cart__add-to-cart-button product-cart__button--custom"
      :text="isRestrictedCountry ? $t('see-product') : addToCartText"
      data-testid="addToCartButtonProductBox"
      :disabled="checkoutIsDisabled"
      @click="isRestrictedCountry ? $router.push(link) : onAddQuantity()"
    />
    <NotifyMe
      v-else
      :product-sku="sku"
    />
  </div>
</template>

<script lang="ts">


import isQuickAddToCartRestricted from '~~/helpers/Checkout/quickAddToCart/isQuickAddToCartRestricted';
import { isCheckoutDisabled } from '~~/helpers/Checkout/isCheckoutDisabled';
import { MAX_SINGLE_PRODUCT_CART_QUANTITY } from '~~/constants/checkout';

export default defineComponent({
  name: 'AddToCartButton',

  props: {
    link: {
      type: String,
      required: true,
    },
    sku: {
      type: String,
      required: true,
    },
    fullProductPrice: {
      type: Number,
      required: true,
    },
    isInStock: {
      type: Boolean,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    stock: {
      type: Number,
      required: true,
    },
  },
  emits: ['click'],
  setup(props) {

    const i18n = useI18n();
    const QUANTITY_TO_ADD = 1;
    const slug = computed(() => props.link.substring(1));
    const addToCartText = i18n.t('Add to cart').toString();
    const {
      quantityInCart,
    } = useAddToCart(slug.value, toRef(props, 'sku').value);
    const { addQuantity } = useAddToCartQuantity({
      sku: toRef(props, 'sku').value,
      slug: slug.value,
      fullProductPrice: toRef(props, 'fullProductPrice').value,
      productName: toRef(props, 'name').value,
      productImage: toRef(props, 'image').value,
      isMainProduct: false,
      addToCartText,
    });


    const { countryCode } = useLocalization();
    const isRestrictedCountry = computed(() => isQuickAddToCartRestricted(countryCode.value));

    const canAddToCart = computed(() => (
      props.isInStock
      && (props.stock - quantityInCart.value) !== 0
      && quantityInCart.value < MAX_SINGLE_PRODUCT_CART_QUANTITY
    ));

    const onAddQuantity = () => {

      addQuantity(QUANTITY_TO_ADD);

    };

    const checkoutIsDisabled = isCheckoutDisabled(countryCode.value);

    return {
      onAddQuantity,
      slug,
      isRestrictedCountry,
      addToCartText,
      checkoutIsDisabled,
      canAddToCart,
    };

  },
});

</script>

<style lang="scss" scoped>
  .product-cart__button--custom {
    --button-text-transform: none;
    --button-width: 100%;
    --button-font-weight: 600;
  }
</style>
